/*
 * Copyright (c) 2018. CPP, Inc. All rights reserved.
 * Also protected by Patent Pending: 15/916,593
 */

import PropTypes from 'prop-types'
import { graphql } from 'gatsby'
import photoShape from './Photo'

const rawList = PropTypes.shape({
  all: PropTypes.arrayOf({
    barPlot: photoShape.raw.isRequired,
  }).isRequired,
})

const barPlotShape = { ...photoShape, rawList }

export default barPlotShape

export const barPlotFragment = graphql`
  fragment BarPlot on ImageSharp {
    fields {
      title
      slug
    }
    original {
      src
      height
      width
    }
  }
`
